import React from 'react'

const Header = () => {
  return (
    <div className='header'>
        The Viral News
    </div>
  )
}

export default Header